'use client'

import React, { MouseEvent } from 'react'
import classNames from 'classnames'
import {
  useComponentVisible,
  useTranslations,
  useSiteContext,
  useUserSettings,
} from '@dustin-web/microsite-components/src/hooks'
import { GetContactQuery } from '@dustin-web/microsite-data/src/graphql/product/generated/graphql-types'
import { useAuth } from '@dustin-web/microsite-components/src/auth'
import { DigitalData } from '@dustin-web/microsite-components/src/utils/digital-data'
import LogInIcon from '@dustin-web/microsite-components/src/icon/generated/log-in'
import Tooltip from '@dustin-web/microsite-components/src/tooltip'

type Props = {
  contactQueryData?: GetContactQuery | null
  contactQueryError?: Error | null
}
export const AccountMenuLogin = ({ contactQueryData, contactQueryError }: Props) => {
  if (contactQueryError) {
    throw contactQueryError
  }

  const { translate } = useTranslations()
  const { componentRef, isVisible } = useComponentVisible<HTMLLIElement>(false)
  const { isProxied } = useSiteContext()
  const { twoLetterISOLanguageName } = useUserSettings()
  const { signIn, userData } = useAuth()

  const contact = contactQueryData?.contact
  const isAdmin = userData?.allowImpersonateContact ?? false

  const loginHandler = (e: MouseEvent<HTMLAnchorElement>) => {
    e.preventDefault()

    DigitalData.accountLogin('header')

    if (!isProxied) {
      signIn({
        provider: 'okta',
        bounceUrl: window.location.origin + '/bounce/login',
        language: twoLetterISOLanguageName,
      })

      return false
    }

    window.location.href = '/login?returnUrl=' + window.location.href
  }

  return (
    <>
      <li
        className={classNames('c-header__user-item c-header__dropdown', {
          'c-header__dropdown--active': isVisible,
        })}
        ref={componentRef}>
        <a
          id="dustin-registration-header-link"
          href="/login"
          className="c-header__user-btn c-header__dropdown-btn button-stripped"
          onClick={loginHandler}
          aria-label={translate('Header_Login')}>
          <span className="c-header__user-icon">
            <Tooltip
              popoverLayerClassName="c-header__user-btn--tooltip"
              tooltipText={translate('Header_Login')}>
              <LogInIcon name={'log-in'} />
            </Tooltip>
          </span>
          <div className="u-relative d-flex flex-column no-mouseflow-dom">
            {isAdmin && (
              <div className="c-header__user-admin c-badge t-purple">
                {translate('AccountMenu_Impersonate')}
              </div>
            )}
            <div
              className={classNames('c-header__user-title c-header__user-title_md-hidden', {
                'no-mouseflow-dom': contact,
              })}>
              {translate('Header_Login')}
            </div>
          </div>
        </a>
      </li>
    </>
  )
}

export default AccountMenuLogin
